import { render, staticRenderFns } from "./ResponsibleIcon.vue?vue&type=template&id=62a6bbde&"
import script from "./ResponsibleIcon.vue?vue&type=script&lang=js&"
export * from "./ResponsibleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports